import { render, staticRenderFns } from "./Import.html?vue&type=template&id=2bf0fbd0&scoped=true&external"
import script from "./Import.ts?vue&type=script&lang=ts&external"
export * from "./Import.ts?vue&type=script&lang=ts&external"
import style0 from "./Import.scss?vue&type=style&index=0&id=2bf0fbd0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0fbd0",
  null
  
)

export default component.exports